import { useMemo } from 'react'
import { useAppContext } from '../containers/App'
import { useConsoleContext } from '../containers/Console'
import { getProjectRoutesRoot } from '../containers/Project'
import { NewRouteDefinition } from '../routes'

export const useProjectRoutes = (): NewRouteDefinition[] => {
  const { featureFlags } = useAppContext()
  const { me, navProject, remotes } = useConsoleContext()

  const serviceIds = useMemo(() => {
    const projectServices = navProject?.id
      ? me.projectServices[navProject.id]
      : []
    return projectServices.map((ps) => ps.id)
  }, [navProject?.id, me.projectServices])

  return navProject?.id
    ? getProjectRoutesRoot(remotes, {
        projectId: navProject.id,
        authGroups: me.authGroups,
        featureFlags,
        serviceIds,
      })
    : []
}
